<template>
	<div class="autocomplete-text">
		<input type="text"
		:id="passedId"
		:value="value"
        autocomplete="off" 
		></input>
	</div>
</template>

<script>
export default {
	props: {
		passedId: null,
		value: null,
		vuexStore: null,
		vuexAction: null,
		vuexFormTab: null,
		enableButtonAction: null,
		dataIndex: null, // usage for adding new request
        field: null,
	},

	methods: {
		enableButton(){
			VueStore.dispatch(this.vuexStore + '/setShowButton', {key: 'canMakeRequest', bool: true});
        },
	},

	mounted () {
		var vThis = this;
		$('#' + vThis.passedId).datepicker({
            dateFormat: 'mm/dd/y',
            onSelect: function(dateText, inst) {
                var date = $(this).val();
                // if vuexFormTab is set
                if(typeof vThis.vuexFormTab !== 'undefined'){
                	VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {formTab: vThis.vuexFormTab, key: vThis.passedId, value: date});
                // if dataIndex is set - usage in adding new request to track the index of multiple request
                } else if(typeof vThis.dataIndex !== 'undefined'){
                    VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {dataIndex: vThis.dataIndex, key: vThis.field, value: date});
                } else {
                	VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {key: vThis.field, value: date});
                }

                vThis.enableButton();
            }

        }).on("change", function(dateText, inst){
        	var date = $(this).val();
        	
                // if vuexFormTab is set
                if(typeof vThis.vuexFormTab !== 'undefined'){
                	VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {formTab: vThis.vuexFormTab, key: vThis.field, value: date});
                // if dataIndex is set - usage in adding new request to track the index of multiple request
                } else if(typeof vThis.dataIndex !== 'undefined'){
                	VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {dataIndex: vThis.dataIndex, key: vThis.field, value: date});
                } else {
                	VueStore.dispatch(vThis.vuexStore + '/' + vThis.vuexAction, {key: vThis.field, value: date});
                }

            vThis.enableButton();
        });

	},
}
</script>

<style scoped>
.autocomplete-text input{
	height: 2.25em;
	font-size: 14px;
	padding: 0 5px;
	border: 1px solid #CCCCCC;
	width: 100%;
}
</style>